export default {
  primary: {
    lighten1: '#5b4c81',
    lighten2: '#53437a',
    lighten3: '#4b3a74',
    lighten4: '#42316e',
    lighten5: '#3b2868',
    base: '#2A165B',
    alpha1: 'rgba(99,84,135,0.3)',
    darken1: '#6b5d8d',
    darken2: '#746794',
    darken3: '#7c6f9a',
    darken4: '#897ea4'
  },
  'new-primary': '#2A165B',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  background: '#303030'
}
